import Utils from './Utils';

/**
 * @param {import('../models/Bricks/BrickCore').default} brick
 * @returns {object|string|null}
 */
export function getMessageShowOption(brick) {
    const message = brick.getOption('message');
    if (message && (typeof message === 'string' || Object.keys(message).length > 0))
        return message;

    const variants = brick.getOption('variants');
    if (Array.isArray(variants) && variants.length > 0)
        return variants[0]?.message ?? null;

    return null;
}

/**
 * @param {import('../models/Bricks/BrickCore').default} brick
 * @param {object} context
 * @param {string} lang
 * @returns {string}
 */
export function resolveMessageShowHtml(brick, context, lang) {
    const raw = Utils.localized_or_fallback(getMessageShowOption(brick), lang, '');
    if (!raw)
        return '';
    return Utils.replaceShortcodes(raw, { ...context, lang });
}

/**
 * @param {import('../models/Workflow').default} workflow
 * @returns {import('../models/Bricks/BrickCore').default|null}
 */
export function getLastMessageShowBrick(workflow) {
    const last_id = workflow?.context?.__last_completed_brick__;
    if (!last_id)
        return null;

    const brick = (workflow?.bricks || []).find((b) => String(b.id) === String(last_id));
    if (!brick || brick.type !== 'message.show')
        return null;

    return brick;
}

/**
 * Resolves the message.show brick to display after completion.
 * __last_completed_brick__ may point at a parallel server brick (e.g. email), not message.show.
 *
 * @param {import('../models/Workflow').default} workflow
 * @returns {import('../models/Bricks/BrickCore').default|null}
 */
export function findMessageShowBrickForEndScreen(workflow) {
    const from_last = getLastMessageShowBrick(workflow);
    if (from_last)
        return from_last;

    const bricks = workflow?.bricks || [];
    const completed = Array.isArray(workflow?.context?.__wf_completed__)
        ? workflow.context.__wf_completed__.map((id) => String(id))
        : [];

    for (let i = completed.length - 1; i >= 0; i -= 1) {
        const brick = bricks.find((b) => String(b.id) === completed[i]);
        if (brick?.type === 'message.show')
            return brick;
    }

    const current = workflow?.getCurrentBrick?.();
    if (current?.type === 'message.show')
        return current;

    const message_show_bricks = bricks.filter((b) => b.type === 'message.show');
    if (message_show_bricks.length === 1 && workflow?.succeeded?.())
        return message_show_bricks[0];

    return null;
}

/**
 * @param {import('../models/Workflow').default} workflow
 * @returns {boolean}
 */
export function workflowHasMessageShowEnd(workflow) {
    return Boolean(findMessageShowBrickForEndScreen(workflow));
}
